import { useRoutes } from 'react-router-dom';

// routes
import ThemeRoutesFullLayout from './Router';
import AuthenticationRoutes from './AuthenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([ThemeRoutesFullLayout, AuthenticationRoutes], '');
}
